import { Icon, IconNameEnum } from '@/React/Shared/Component/Icon'
import { ScreenOverlay } from '@/React/Shared/Component/ScreenOverlay'

interface GeneratingBusinessNamesLoadingOverlayProps {
    show: boolean
}

export function GeneratingBusinessNamesLoadingOverlay({
    show,
}: GeneratingBusinessNamesLoadingOverlayProps) {
    if (!show) {
        return null
    }

    return (
        <ScreenOverlay aria-hidden={false}>
            <div
                role="status"
                className="flex flex-col items-center justify-center gap-4"
            >
                <Icon
                    name={IconNameEnum.LoadingSpinner}
                    className="animate-spin w-10 h-10 text-white"
                    aria-hidden="true"
                />
                <div className="text-white text-3xl font-semibold px-4 text-center">
                    Generating business names, please wait...
                </div>
            </div>
        </ScreenOverlay>
    )
}
